import { useState } from "react"
import { submitFeedback } from "../utils/submit_forms"

const useFeedbackCollector = () => {
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)

  const submit = async (email, location, message) => {
    setLoading(true)
    try {
      // send the email to the back end api
      const resp = await submitFeedback(email, location, message)
      if (resp && resp.status === 200) {
        setSuccess(true)
      } else {
        const jsonResp = JSON.parse(resp.body)
        // eslint-disable-next-line no-console
        console.log("Form error", jsonResp.error)
        setError(`Error submitting feedback: ${jsonResp.error}`)
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
      setError(`Error submitting email: ${e.toString()}`)
    } finally {
      setLoading(false)
    }
  }

  return {
    success,
    error,
    loading,
    submit,
  }
}

export default useFeedbackCollector
